

/**
 * 2019-11-04
 * handan
 * sdk的公共函数
 */

class Base {
  constructor(){
    this.contrastObj = this.contrastObj.bind(this) ;
  }
  // 检查两个对象或者数组是否完全相等
  contrastObj(params, obj){
    function Types(argument){
      return Object.prototype.toString.call(argument)
    }
    if(Types(params) !== Types(obj)){
      return false ;
    }
    if(JSON.stringify(params).length !== JSON.stringify(obj).length){
      return false ;
    } 
    // 123 234
    if(Types(params) === Types(obj) && (Types(params) !== "[object Object]" || Types(params) !== "[object Array]")){
      for(let key in params){
        if(typeof params[key] === "object"){
          let result = this.contrastObj(params[key], obj[key])
          if(!result){
            return false ;
          }
        }else{
          if(params[key] !== obj[key]){
            return false ;
          }
        }
      }
      return true ;
    }else{
      return false ;
    }
  }
}

export default Base ;